import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * EdisonDragIndicatorIcon
 * A custom drag/resize indicator composed of two subtle diagonal lines
 * matching the provided design reference. It intentionally keeps a light stroke
 * using currentColor so parent styling (sx color, etc.) can control appearance.
 */
const EdisonDragIndicatorIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" focusable="false" fontSize={props.fontSize || 'small'}>
        <g
            stroke="currentColor"
            strokeWidth={1.4}
            strokeLinecap="round"
            fill="none"
            strokeOpacity={0.55}
            transform="rotate(-90 12 12) translate(2 -2)"
        >
            {/* Longest line (rotated & shifted) */}
            <line x1={18} y1={18} x2={4} y2={4} />
            {/* Medium line (rotated & shifted) */}
            <line x1={18} y1={14} x2={8} y2={4} />
            {/* Shortest line (rotated & shifted) */}
            <line x1={18} y1={10} x2={12} y2={4} />
        </g>
    </SvgIcon>
);

export default EdisonDragIndicatorIcon;
